import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';

import { FileMultiUploaderEntity } from '@rp/shared/models';

export function atLeastOneFileValidator<T extends FileMultiUploaderEntity[]>(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control || !(control instanceof Array || control instanceof FormArray)) {
    return null;
  }

  const files: T = control.value || [];
  const hasAtLeastOneFile = files.some(fileControl => fileControl && fileControl.file);

  return hasAtLeastOneFile ? null : { atLeastOneFileRequired: true };
}
